import axios from 'axios';
import { Action } from '../types';

export default {
  [Action.SEND_ORDER]({ commit, state }, order) {
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_API_URL  + 'cartridges', order)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

